const INPUT_BAR_ESTIMATED_HEIGHT = 36;
const INPUT_BAR_IDLE_WIDTH = 280;
const ANCHOR_GAP = 12;
const VIEWPORT_INSET = 12;

/** Where a summoned cursor input opens: centred under the surface that
 *  summoned it, or at the bottom centre of the window without one. */
export function resolveCursorInputAnchor(surface: DOMRect | undefined): {
  x: number;
  y: number;
} {
  if (surface) {
    return {
      x: surface.left + (surface.width - INPUT_BAR_IDLE_WIDTH) / 2,
      y: surface.bottom + ANCHOR_GAP,
    };
  }
  return {
    x: (window.innerWidth - INPUT_BAR_IDLE_WIDTH) / 2,
    y: Math.max(
      12,
      window.innerHeight - INPUT_BAR_ESTIMATED_HEIGHT - VIEWPORT_INSET,
    ),
  };
}
